import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Loader2, Sparkles, Fingerprint } from "lucide-react";

const Col = ({ title, items, color, testId }) => (
  <div className="qs-panel p-4" data-testid={testId}>
    <div className="text-[10px] uppercase tracking-widest mb-2" style={{ color }}>{title}</div>
    <ul className="space-y-2 text-xs text-slate-300">{items.map((x) => <li key={x} className="border-l-2 pl-2" style={{ borderColor: color }}>{x}</li>)}</ul>
  </div>
);

export const PolicyPanel = ({ city }) => {
  const { lang } = useLang();
  const [p, setP] = useState(null);
  useEffect(() => {
    setP(null);
    axios.get(`${API}/commons/policy`, { params: { city, lang } }).then((r) => setP(r.data)).catch(() => setP({ error: true }));
  }, [city, lang]);
  if (!p) return <div className="flex items-center gap-2 text-sm text-slate-500 py-8" data-testid="policy-loading"><Loader2 className="h-4 w-4 animate-spin" /> Deriving policy from price board, futures proxies and anomalies…</div>;
  if (p.error) return <p className="text-sm text-slate-500">Policy unavailable.</p>;
  return (
    <div className="space-y-4" data-testid="policy-panel">
      <div className="grid md:grid-cols-3 gap-3">
        <Col title="Short term · 0–3 months" items={p.short_term} color="#EF4444" testId="policy-short" />
        <Col title="Medium term · 12 months" items={p.medium_term} color="#F59E0B" testId="policy-medium" />
        <Col title="Long term · 36 months" items={p.long_term} color="#00FF7F" testId="policy-long" />
      </div>
      <div className="qs-grad-border p-5" data-testid="policy-narrative">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#F59E0B] mb-2"><Sparkles className="h-3.5 w-3.5" /> Collective executive brief · Claude Sonnet 5</div>
        <p className="text-sm text-slate-300 leading-relaxed whitespace-pre-line">{p.narrative.replace(/\*\*/g, "")}</p>
        <div className="text-[10px] font-mono text-slate-600 mt-3 flex items-center gap-1"><Fingerprint className="h-3 w-3" /> policy {p.policy_hash} · {p.open_anomalies} open anomalies</div>
      </div>
    </div>
  );
};
